import Button from "@mui/material/Button";
import HtmlToolTip from "../../generic/HtmlToolTip";
import { FaInfoCircle } from "react-icons/fa";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

const DashboardTooltip = ({ title, children }) => {
  return (
    <HtmlToolTip
      title={
        <>
          {title && <Typography>{title}</Typography>}
          {children}
        </>
      }
    >
      <Button
        style={{
          minWidth: 0,
          paddingLeft: "5px",
          color: "rgb(60,60,60)",
        }}
      >
        <FaInfoCircle />
      </Button>
    </HtmlToolTip>
  );
};

DashboardTooltip.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default DashboardTooltip;
